module.exports = __webpack_public_path__ + "img/NewsFeedEmpty.1956ca35.png";